module.exports = __webpack_public_path__ + "static/images/components/Back/images/shine-to-left.503ab52a.png";


//////////////////
// WEBPACK FOOTER
// ./components/Back/images/shine-to-left.png
// module id = 2496
// module chunks = 11